import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.6 13.2a7 7 0 1 0-1.4 1.4 1 1 0 0 0 .093.107l5.5 5.5a1 1 0 0 0 1.414-1.414l-5.5-5.5a1 1 0 0 0-.107-.093M14 9A5 5 0 1 1 4 9a5 5 0 0 1 10 0",
      clipRule: "evenodd"
    }
  )
);
var SvgSearchOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SearchOutlined_default = SvgSearchOutlined;

export { SearchOutlined_default as default };
